import { render } from "./PasswordReset.vue?vue&type=template&id=9ea98006&ts=true"
import script from "./PasswordReset.vue?vue&type=script&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__